// extracted by mini-css-extract-plugin
module.exports = {"mask":"svg_mask__M3c65"};